import { prop } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export class Delegation extends Resource {
    public override type = 'delegations';
    
    @prop()
    public name!: string;

}